export default __webpack_public_path__ + "static/media/b05be70f0d805070.2a3d8c8747843fddb81effd438703b69.svg";